var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    className: "wd-accent-heartbeat wd-accent",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DBA",
    fillRule: "nonzero",
    d: "M46.984 11.277c5.93 5.385 5.93 14.381.07 19.895l-18 18a2 2 0 0 1-2.83 0L8.27 31.215c-5.75-5.41-5.601-13.866-.098-19.815 5.282-5.71 13.837-5.858 19.468-.468 5.47-5.23 13.508-4.954 19.345.345zM47.844 27c2.697-4.607 1.962-10.458-2.206-14.242-5.061-4.595-12.174-5.01-17 0l-1 1-1-1c-4.826-5.01-12.365-5.01-17 0C5.83 16.875 4.863 22.488 7.445 27h4.289c1.824-1 3.708-1 5.532 0H20a1 1 0 0 1 .832.445l.66.992 2.527-12.633c.227-1.132 1.872-1.044 1.977.105l1.376 15.134.647-3.24A1 1 0 0 1 29 27h3.573c1.32-1.317 2.806-2 4.427-2 1.567 0 3.046.684 4.414 2h6.43zm-1.464 2H41a1 1 0 0 1-.722-.308C39.176 27.542 38.091 27 37 27c-1.15 0-2.224.537-3.261 1.674A1 1 0 0 1 33 29h-3.18l-1.84 9.196c-.226 1.132-1.871 1.044-1.976-.105l-1.376-15.134-1.647 8.24c-.175.873-1.319 1.099-1.813.358L19.465 29H17a1 1 0 0 1-.514-.143c-1.35-.81-2.622-.81-3.972 0A1 1 0 0 1 12 29H8.896c.233.259.48.512.742.758l18 18 18-18c.26-.245.508-.498.742-.758z",
    className: "color-500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.844 27h-6.43c-1.368-1.316-2.847-2-4.414-2-1.621 0-3.107.683-4.427 2H29a1 1 0 0 0-.98.804l-.648 3.239-1.376-15.134c-.105-1.149-1.75-1.237-1.977-.105l-2.526 12.633-.66-.992A1 1 0 0 0 20 27h-2.734c-1.824-1-3.708-1-5.532 0H7.445C4.863 22.487 5.83 16.875 9.638 12.758c4.635-5.01 12.174-5.01 17 0l1 1 1-1c4.826-5.01 11.939-4.595 17 0 4.168 3.784 4.903 9.635 2.206 14.242zm-1.464 2c-.234.26-.482.513-.742.758l-18 18-18-18c-.262-.246-.51-.5-.742-.758H12a1 1 0 0 0 .514-.143c1.35-.81 2.622-.81 3.972 0A1 1 0 0 0 17 29h2.465l1.703 2.555c.494.741 1.638.515 1.813-.359l1.647-8.239 1.376 15.134c.105 1.149 1.75 1.237 1.977.105L29.82 29H33a1 1 0 0 0 .739-.326C34.776 27.537 35.85 27 37 27c1.091 0 2.176.542 3.278 1.692A1 1 0 0 0 41 29h5.38z",
    className: "french-vanilla-100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.c6823bf26a30bd71ca8f4e9318778661.svg";
export { ForwardRef as ReactComponent };